import { useState } from "react";
import { Loader2 } from "lucide-react";
import { boxInput } from "../../lib/format";

const FIELDS = [
  ["name", "Full name", "text", true],
  ["phone", "Phone", "tel"],
  ["email", "Email", "email"],
  ["designation", "Designation", "text"],
  ["site", "Site / client", "text"],
  ["date_joined", "Date joined", "date"],
];

export const EmployeeForm = ({ initial = {}, onSubmit, submitLabel, passwordRequired }) => {
  const [f, setF] = useState({ name: "", phone: "", email: "", designation: "", site: "", date_joined: "", password: "", ...initial });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { ...f };
    if (!body.password) delete body.password;
    try { await onSubmit(body); } finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="employee-form">
      {FIELDS.map(([k, l, t, req]) => (
        <label key={k} className="text-sm">
          <span className="overline text-[var(--bone-2)]">{l}{req && <span className="text-[var(--signal)]"> *</span>}</span>
          <input type={t} required={req} value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} className={`${boxInput} mt-1`} data-testid={`employee-${k}-input`} />
        </label>
      ))}
      <label className="text-sm sm:col-span-2">
        <span className="overline text-[var(--bone-2)]">{passwordRequired ? "Login password" : "New password (leave blank to keep)"}{passwordRequired && <span className="text-[var(--signal)]"> *</span>}</span>
        <input type="text" minLength={6} required={passwordRequired} value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })}
          placeholder="Min 6 characters" className={`${boxInput} mt-1`} data-testid="employee-password-input" autoComplete="new-password" />
      </label>
      <button type="submit" disabled={busy} className="flex items-center justify-center gap-2 rounded-full bg-[var(--signal)] px-6 py-3 font-semibold text-[var(--ink)] disabled:opacity-60 sm:col-span-2 sm:justify-self-start" data-testid="employee-submit-button">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} {submitLabel}
      </button>
    </form>
  );
};
